import { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUsers, updateUserRoles, updateUserLocations, deleteUsers } from '@redux/features/usersSlice';
import { addNotification } from '@redux/features/notificationsSlice';

export const useUsers = () => {
  const dispatch = useDispatch();
  const { users, isLoading, error } = useSelector((state) => state.users);
  const { locations, isLoading: isLocationsLoading, error: locationsError } = useSelector((state) => state.locations);
  const [changedRoles, setChangedRoles] = useState({});
  const [changedLocations, setChangedLocations] = useState({});

  useEffect(() => {
    dispatch(getUsers());
  }, []);

  useEffect(() => {
    if (error || locationsError) {
      dispatch(
        addNotification({
          id: Date.now(),
          title: error || locationsError,
          type: 'error',
        })
      );
    }
  }, [error, locationsError]);

  const handleSaveChanges = useCallback(async () => {
    if (Object.keys(changedRoles).length) {
      const result = await dispatch(updateUserRoles(changedRoles));
      if (result.meta?.requestStatus === 'fulfilled') {
        setChangedRoles({});
        dispatch(addNotification({ id: Date.now(), title: 'Ролі оновлено', type: 'success' }));
      }
    }

    if (Object.keys(changedLocations).length) {
      const result = await dispatch(updateUserLocations(changedLocations));
      if (result.meta?.requestStatus === 'fulfilled') {
        setChangedLocations({});
        dispatch(addNotification({ id: Date.now(), title: 'Локації оновлено', type: 'success' }));
      }
    }
  }, [dispatch, changedRoles, changedLocations]);

  const handleDelete = async (selectedIDs, clearSelection) => {
    if (selectedIDs.length > 0) {
      const result = await dispatch(deleteUsers(selectedIDs));

      if (result.meta.requestStatus === 'fulfilled') {
        dispatch(
          addNotification({
            id: Date.now(),
            title: 'Користувачі успішно видалені',
            type: 'success',
          })
        );
        clearSelection();
      }
    }
  };

  return {
    users,
    locations,
    isLoading,
    changedRoles,
    changedLocations,
    isLocationsLoading,
    handleDelete,
    setChangedRoles,
    handleSaveChanges,
    setChangedLocations,
  };
};
